import { deviceService } from "../_services";
import { basePerimeter } from '../_perimeters/index';
import moment from "moment";
import { isEmpty } from "lodash";

export default {
  namespaced: true,
  state: {
    devices: [],
    events: [],
    installation_history: {},
    config: {},
    device: {
      online: null,
      lastMsgTime: null
    }
  },
  actions: {
    findAll({ commit }, onlyActiveCircuits=true) {
      deviceService
        .findAll(onlyActiveCircuits)
        .then(response => {
          commit("findAllSuccess", response.data);
        })
        .catch(error => {
          commit("findAllFailure", error);
          this.dispatch("alert/error", "Something has went wrong, please contact support.");
        });
    },
    findByCircuit({ commit }, circuitUuid) {
      deviceService
        .findByCircuit(circuitUuid)
        .then(response => {
          commit("findAllSuccess", response.data);
        })
        .catch(error => {
          commit("findAllFailure", error);
          this.dispatch("alert/error", "Error getting device list.");
        });
    },
    getDeviceInstallationHistory({ commit }, serialNum) {
      return deviceService
        .getDeviceInstallationHistory(serialNum)
        .then(response => {
          commit("findInstallationHistorySuccess", response.data);
        })
        .catch(error => {
          commit("findInstallationHistoryFailure", error);
          const errorStatus = error.response && error.response.status;
          let errorMessage;
          if (errorStatus >= 400 && errorStatus < 500) {
            errorMessage = "Cannot obtain device installation history.";
          } else {
            errorMessage = "Something has went wrong, please contact support.";
          }
          this.dispatch("alert/error", errorMessage);
        });
    },
    saveDeviceInstallationHistory({ commit }, payload) {
      const newDeviceInstallationHistory = convertInstallationHistory(payload.installationHistory, false);
      return deviceService
        .saveDeviceInstallationHistory(payload.serial, newDeviceInstallationHistory)
        .then(response => {
          commit("saveDeviceInstallationHistorySuccess");
          this.dispatch("alert/success", "Device Install History Saved Sucessfully");
          this.dispatch("device/getDeviceInstallationHistory", payload.serial)
        })
        .catch(error => {
          commit("saveDeviceInstallationHistoryFailure");
          let errorMessage = "Error saving device history - " + error.response.data.message + " - " + error.response.data.device_serial;
          this.dispatch("alert/error", errorMessage);
          return Promise.reject();
        });
    },
    getDeviceConfig({ commit }, serialNum) {
      return deviceService
        .getDeviceConfig(serialNum)
        .then(response => {
          let config = response.data.setConfig
          config.trigger_config = response.data.readConfig.trigger_config
          commit("getConfigSuccess", config);
        })
        .catch(error => {
          commit("getConfigFailure", error);
          const errorStatus = error.response && error.response.status;
          let errorMessage;
          if (errorStatus >= 400 && errorStatus < 500) {
            errorMessage = "Cannot obtain device config.";
          } else {
            errorMessage = "Cannot obtain device configuration";
          }
          this.dispatch("alert/error", errorMessage);
          return Promise.reject('GetConfigFailed');
        });
    },
    installDevice({ commit }, device) {
      return deviceService.installDevice(device);
    },
    uninstallDevice({ commit }, device) {
      return deviceService.uninstallDevice(device);
    },
    saveDeviceConfig({ commit }, payload) {
      const newConfig = convertDeviceConfig(payload.config, true);
      commit("updateDeviceConfig", newConfig);
      return deviceService
        .saveDeviceConfig(payload.serial, newConfig)
        .then(response => {
          commit("saveConfigSuccess");
          this.dispatch("alert/success", "Device Config Saved Sucessfully");
          this.dispatch("device/getDeviceConfig", payload.serial)
        })
        .catch(error => {
          commit("saveConfigFailure");
          const errorStatus = error.response && error.response.status;
          let errorMessage = "Error saving device config - please try again. If you are continually having issues, then please contact support - " + error.response.data.message;
          this.dispatch("alert/error", errorMessage);
          return Promise.reject();
        });
    },
    updateDeviceInstallationHistory({ commit }, installationHistory) {
      commit("updateDeviceInstallationHistory", installationHistory);
    },
    updateDeviceConfig({ commit }, config) {
      commit("updateDeviceConfig", config);
    },
    updateConfigThresholdSwitch({ commit }, value) {
      commit("updateConfigThresholdSwitch", value);
    },
    saveDevice({ commit }, value) {
      commit('saveDevice', value)
    },
    saveDeviceOnline({ commit }, value) {
      commit('saveDeviceOnline', value)
    }
  },
  getters: {
    devices: state => state.devices,
    events: state => state.events,
    devicesNotInstalled: state => {
      return state.devices.filter(device => !isEmpty(device) && device.pole == null);
    },
    devicesNotInstalledSerials: state => {
      return state.devices.filter(device => !isEmpty(device) && device.pole == null).map(device => device.product_serial_num);
    },
    existingDeviceSerials: state => {
      return state.devices.map(device => device.product_serial_num);
    },
    installation_history: state => state.installation_history,
    deviceOnline: state => state.device.online,
    deviceLastMsgTime: state => state.device.lastMsgTime
  },
  mutations: {
    findAllSuccess(state, devices) {
      state.devices = devices.devices;
    },
    findAllFailure(state) {
      state.devices = [];
    },
    findInstallationHistorySuccess(state, installation_history) {
      state.installation_history = convertInstallationHistory(installation_history, true) || {};
    },
    findInstallationHistoryFailure(state, error) {
      state.installation_history = {};
    },
    getConfigSuccess(state, config) {
      state.config = convertDeviceConfig(config, false) || {};
    },
    getConfigFailure(state, error) {
      state.config = {};
    },
    updateDeviceInstallationHistory(state, installationHistory) {
      // state.installation_history = installationHistory;
    },
    updateDeviceConfig(state, config) {
      state.config = config;
    },
    updateConfigThresholdSwitch(state, value) {
      state.config.reconfigured.trigger_config_enabled = value;
    },
    saveConfigSuccess(state) { },
    saveConfigFailure(state) { },
    saveDeviceInstallationHistorySuccess(state) { },
    saveDeviceInstallationHistoryFailure(state) { },
    saveDevice(state, device) {
      state.device = device;
    },
    saveDeviceOnline(state, value) {
      state.device.online = value;
    }
  }
};

function convertDeviceConfig(configInput, inverse) {
  let configModified = _.cloneDeep(configInput);
  let fieldMap = new Map([
    ['phase1MLSSequence', 'channels[0].mls.enabled'],
    ['phase1MLSA', 'channels[0].mls.codes[0]'],
    ['phase1MLSB', 'channels[0].mls.codes[1]'],
    ['phase1MLSC', 'channels[0].mls.codes[2]'],
    ['phase1AnalogGainTX', 'channels[0].vga_gain.tx'],
    ['phase1AnalogGainRX', 'channels[0].vga_gain.rx'],
    ['phase1ImpedanceMatching', 'channels[0].impedance_matching'],
    ['phase1CurrentPolarityInverted', 'channels[0].inverted_current'],
    ['phase2MLSSequence', 'channels[1].mls.enabled'],
    ['phase2MLSA', 'channels[1].mls.codes[0]'],
    ['phase2MLSB', 'channels[1].mls.codes[1]'],
    ['phase2MLSC', 'channels[1].mls.codes[2]'],
    ['phase2AnalogGainTX', 'channels[1].vga_gain.tx'],
    ['phase2AnalogGainRX', 'channels[1].vga_gain.rx'],
    ['phase2ImpedanceMatching', 'channels[1].impedance_matching'],
    ['phase2CurrentPolarityInverted', 'channels[1].inverted_current'],
    ['phase3MLSSequence', 'channels[2].mls.enabled'],
    ['phase3MLSA', 'channels[2].mls.codes[0]'],
    ['phase3MLSB', 'channels[2].mls.codes[1]'],
    ['phase3MLSC', 'channels[2].mls.codes[2]'],
    ['phase3AnalogGainTX', 'channels[2].vga_gain.tx'],
    ['phase3AnalogGainRX', 'channels[2].vga_gain.rx'],
    ['phase3ImpedanceMatching', 'channels[2].impedance_matching'],
    ['phase3CurrentPolarityInverted', 'channels[2].inverted_current'],
    ['overVoltageChannel1', 'trigger_activation.over_current_trigger[0]'],
    ['overVoltageChannel2', 'trigger_activation.over_current_trigger[1]'],
    ['overVoltageChannel3', 'trigger_activation.over_current_trigger[2]'],
    ['underVoltageChannel1', 'trigger_activation.under_voltage_trigger[0]'],
    ['underVoltageChannel2', 'trigger_activation.under_voltage_trigger[1]'],
    ['underVoltageChannel3', 'trigger_activation.under_voltage_trigger[2]'],
    ['currentAmpThreshold', 'trigger_config.zero_sequence_trigger.current.threshold'],
    ['currentAmpHysteresis', 'trigger_config.zero_sequence_trigger.current.hysteresis'],
    ['currentVecThreshold', 'trigger_config.zero_sequence_trigger.current.vecshift_threshold'],
    ['currentVecHysteresis', 'trigger_config.zero_sequence_trigger.current.vecshift_hysteresis'],
    ['voltageAmpThreshold', 'trigger_config.zero_sequence_trigger.voltage.threshold'],
    ['voltageAmpHysteresis', 'trigger_config.zero_sequence_trigger.voltage.hysteresis'],
    ['voltageVecThreshold', 'trigger_config.zero_sequence_trigger.voltage.vecshift_threshold'],
    ['voltageVecHysteresis', 'trigger_config.zero_sequence_trigger.voltage.vecshift_hysteresis']
  ]);
  if (!inverse) {
    // Create empty property, a trigger switch variable, and an empty trigger config (if it's null)
    configModified.reconfigured = {};
    configModified.reconfigured.trigger_config_enabled = !(configModified.trigger_config === null);
    if (configModified.trigger_config === null) {
      configModified.trigger_config = {
        zero_sequence_trigger: {
          current: {
            threshold: 0,
            hysteresis: 0,
            vecshift_threshold: 0,
            vecshift_hysteresis: 0
          },
          voltage: {
            threshold: 0,
            hysteresis: 0,
            vecshift_threshold: 0,
            vecshift_hysteresis: 0
          }
        },
        under_voltage_trigger: {
          clip_lower: 0,
          clip_upper: 0,
          threshold: 0,
          hysteresis: 0
        },
        over_current_trigger: {
          clip_upper: 0,
          threshold: 0,
          hysteresis: 0
        }
      };
    }
    // Loop the fields and remap them to a different property
    fieldMap.forEach((value, key) => {
      configModified.reconfigured[key] = _.get(configModified, value);
    });
  } else {
    // Loop through and Remap Variables to the correct position
    fieldMap.forEach((value, key) => {
      _.set(configModified, value, configModified.reconfigured[key]);
    });
    // If the switch is not set use a custom trigger config, then set eh object to null
    if (!configModified.reconfigured.trigger_config_enabled) {
      configModified.trigger_config = null;
    }
    // Remove that section for posting to backend
    delete configModified.reconfigured;
    configModified.previous_version = configModified.version;
    delete configModified.version;
  }
  return configModified;
}

// This function cleans the translates the input to interface between web and backend
function convertInstallationHistory(installHistory, requestToWebConversion) {
  let installHistoryModified = _.cloneDeep(installHistory);
  delete installHistoryModified.device_serial;
  const dateFields = ['install_time', 'uninstall_time'];
  const deleteFields = ['pole_substation_number', 'circuit_name', 'circuit_uuid'];
  installHistoryModified.install_history.forEach(element => {
    dateFields.forEach(dateField => {
      if (element[dateField]) {
        if (requestToWebConversion) {
          element[dateField] = moment(element[dateField]).format("YYYY-MM-DD");
        } else {
          if (element[dateField] != null) {
            element[dateField] = moment(element[dateField]).toISOString();
          } else {
            delete element[dateField];
          }
        }
      }
    })
    if (!requestToWebConversion) {
      deleteFields.forEach(deleteField => {
        delete element[deleteField];
      });
    }
  })
  return installHistoryModified;
}
